var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.468,
    height: 18.905,
    viewBox: "0 0 15.468 18.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-security",
    "data-name": "Icon material-security",
    d: "M12.234,1.5,4.5,4.937v5.156a10.694,10.694,0,0,0,7.734,10.312,10.694,10.694,0,0,0,7.734-10.312V4.937Zm0,9.444h6.015a9.2,9.2,0,0,1-6.015,7.682V10.953H6.219v-4.9l6.015-2.673Z",
    transform: "translate(-4.5 -1.5)",
    fill: "rgba(0,0,0,0.73)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcl);
export default __webpack_public_path__ + "static/media/acl.93d58256dca30dd61a1b35cc557090c8.svg";
export { ForwardRef as ReactComponent };